/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/esnext.async-iterator.filter.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/esnext.async-iterator.find.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.iterator.js";
import * as repayService from '@/services/repay';
import { Toast } from 'vant';
import couponPopup from './coupon-popup.vue';
import payAllPopup from './pay-all-popup.vue';
import costDetailPopup from './cost-detail-popup.vue';
import formatAmount from '@/shared/formatAmount';
import { formatDate, customFormatDate } from '@/shared/formatDate';
import TrackingData from '@/shared/reportDataTracking';
import { useUserStore } from '@/stores/modules/user';
import { Dialog } from 'vant';
import { nextTick } from 'vue';
export default {
    __name: 'index',
    setup: function(__props) {
        var userStore = useUserStore();
        var route = useRoute();
        var router = useRouter();
        var active = ref(0);
        var oldId = ref(Number(route.query.borrowContractId));
        var repayList = ref([]);
        var reqContractDetail = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var params, _repayList_value, _ref, paymentRecord, unSettledNeedRepayCount, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            params = {
                                // kindSort: 1, // 1-unsettled, 2-settle
                                originPoint: 1
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                repayService.queryContractDetail(params)
                            ];
                        case 2:
                            _ref = _state.sent(), paymentRecord = _ref.paymentRecord, unSettledNeedRepayCount = _ref.unSettledNeedRepayCount;
                            if (!unSettledNeedRepayCount) {
                                router.push({
                                    path: '/repay/no-order'
                                });
                            }
                            repayList.value = paymentRecord;
                            (_repayList_value = repayList.value) === null || _repayList_value === void 0 ? void 0 : _repayList_value.filter(function(item, index) {
                                if (item.borrowContractId === oldId.value) {
                                    active.value = index;
                                }
                            });
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function reqContractDetail() {
                return _ref.apply(this, arguments);
            };
        }();
        var contractCouponData = ref({}); // { contractId: { couponList: [], eCouponCode: '' } }
        var currentContractId = computed(function() {
            var _repayList_value_active_value;
            return (_repayList_value_active_value = repayList.value[active.value]) === null || _repayList_value_active_value === void 0 ? void 0 : _repayList_value_active_value.borrowContractId;
        });
        var currentCouponCode = computed(function() {
            var _contractCouponData_value_currentContractId_value;
            if (!currentContractId.value) return '';
            return ((_contractCouponData_value_currentContractId_value = contractCouponData.value[currentContractId.value]) === null || _contractCouponData_value_currentContractId_value === void 0 ? void 0 : _contractCouponData_value_currentContractId_value.eCouponCode) || '';
        });
        var currentContractCouponList = computed(function() {
            var _contractCouponData_value_currentContractId_value;
            if (!currentContractId.value) return [];
            return ((_contractCouponData_value_currentContractId_value = contractCouponData.value[currentContractId.value]) === null || _contractCouponData_value_currentContractId_value === void 0 ? void 0 : _contractCouponData_value_currentContractId_value.couponList) || [];
        });
        var getCouponText = function(contractId, couponCode) {
            var _contractData_couponList;
            var contractData = contractCouponData.value[contractId];
            if (!contractData) return '';
            var foundCoupon = (_contractData_couponList = contractData.couponList) === null || _contractData_couponList === void 0 ? void 0 : _contractData_couponList.find(function(item) {
                return item.eCouponCode === couponCode;
            });
            return foundCoupon ? getFormatMoney(foundCoupon) : '';
        };
        var getFormatMoney = function(item) {
            var str = '';
            if (item.discountCode === 2 || item.discountCode === 4) {
                str = "-$ ".concat(formatAmount(item.priceCut, '0,0'));
            } else if (item.discountCode === 1 || item.discountCode === 3) {
                str = "-".concat(item.priceCut, "%");
            }
            return str;
        };
        var reqCouponList = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(contractId) {
                var params, res, promoCodes, existingData, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            params = {
                                originPoint: 4,
                                borrowContractNo: contractId
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                repayService.queryCouponList(params)
                            ];
                        case 2:
                            res = _state.sent();
                            promoCodes = res.promoCodes;
                            existingData = contractCouponData.value[contractId];
                            contractCouponData.value[contractId] = {
                                couponList: promoCodes,
                                eCouponCode: (existingData === null || existingData === void 0 ? void 0 : existingData.eCouponCode) || ''
                            };
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function reqCouponList(contractId) {
                return _ref.apply(this, arguments);
            };
        }();
        var init = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, contract, err;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                reqContractDetail()
                            ];
                        case 1:
                            _state.sent();
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                7,
                                8,
                                9
                            ]);
                            _iterator = repayList.value[Symbol.iterator]();
                            _state.label = 3;
                        case 3:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                6
                            ];
                            contract = _step.value;
                            return [
                                4,
                                reqCouponList(contract.borrowContractId)
                            ];
                        case 4:
                            _state.sent();
                            _state.label = 5;
                        case 5:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                3
                            ];
                        case 6:
                            return [
                                3,
                                9
                            ];
                        case 7:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                9
                            ];
                        case 8:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 9:
                            // force update
                            contractCouponData.value = _object_spread({}, contractCouponData.value);
                            return [
                                2
                            ];
                    }
                });
            });
            return function init() {
                return _ref.apply(this, arguments);
            };
        }();
        init();
        var currPlanObj = ref({});
        var showCostPopup = function(item) {
            isShowCostDetail.value = true;
            currPlanObj.value = item;
        };
        var goRepay = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(formKey) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            isShowPayAllPopup.value = false;
                            return [
                                4,
                                nextTick()
                            ];
                        case 1:
                            _state.sent();
                            router.push({
                                path: '/repay/payment',
                                query: {
                                    formKey: formKey
                                }
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function goRepay(formKey) {
                return _ref.apply(this, arguments);
            };
        }();
        var trackClick = function() {
            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                taskHandler: 'details_repay_screen-repay_click'
            }));
        };
        var isShowPayAllPopup = ref(false);
        var isShowCostDetail = ref(false);
        var clickHelp = function(val) {
            var msgList = {
                overdue: 'Este cupón no está disponible. Por favor, liquida tus préstamos vencidos y vuelve a intentarlo.',
                disable: 'El cupón ha expirado y no se puede utilizar.'
            };
            Dialog({
                width: '70%',
                message: val === 0 ? msgList.overdue : msgList.disable,
                confirmButtonText: 'OK'
            });
        };
        var isShowCouponPopup = ref(false);
        var showCouponPopup = function() {
            isShowCouponPopup.value = true;
            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                taskHandler: 'home_activity-cupon_select'
            }));
        };
        var selectCoupon = function(val) {
            if (!currentContractId.value) return;
            if (!contractCouponData.value[currentContractId.value]) {
                contractCouponData.value[currentContractId.value] = {
                    couponList: [],
                    eCouponCode: ''
                };
            }
            if (val) {
                contractCouponData.value[currentContractId.value].eCouponCode = val.eCouponCode;
            } else {
                contractCouponData.value[currentContractId.value].eCouponCode = '-1';
            }
        };
        var reqBindCouponOnRepay = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var outcomeResult;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!currentContractId.value) return [
                                2
                            ];
                            return [
                                4,
                                repayService.bindCouponOnRepay({
                                    eCouponCode: currentCouponCode.value,
                                    borrowContractNo: currentContractId.value
                                })
                            ];
                        case 1:
                            outcomeResult = _state.sent().outcomeResult;
                            switch(outcomeResult){
                                case '0':
                                    console.log('coupon bind fail, contract overdue');
                                    break;
                                case '1':
                                    console.log('coupon bind success');
                                    break;
                                case '2':
                                    console.log('coupon bind fail, please try again');
                                    Toast('Ocurrió un error, por favor vuelva a vincular el cupón.');
                                    break;
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function reqBindCouponOnRepay() {
                return _ref.apply(this, arguments);
            };
        }();
        var closeCouponPopup = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var dialogOpenTime;
                return _ts_generator(this, function(_state) {
                    if (!currentContractId.value) return [
                        2
                    ];
                    if (currentCouponCode.value && currentCouponCode.value !== '-1') {
                        dialogOpenTime = ref(new Date());
                        TrackingData.trackPopup(_object_spread_props(_object_spread({}, userStore.commonData), {
                            popKindName: 'popup_cupon_confirm',
                            taskHandler: 'popup-show'
                        }));
                        Dialog({
                            width: '70%',
                            title: '¿Estás seguro de que quieres usar el cupón?',
                            message: 'El pedido estará vinculado a este cupón y no podrá modificarse.',
                            showConfirmButton: true,
                            showCancelButton: true,
                            className: 'dialog-bind-coupon'
                        }).then(/*#__PURE__*/ _async_to_generator(function() {
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        console.log('confirm');
                                        return [
                                            4,
                                            reqBindCouponOnRepay()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            4,
                                            init()
                                        ];
                                    case 2:
                                        _state.sent();
                                        // currentContractCouponList.value[0].resultStatus = 5;
                                        isShowCouponPopup.value = false;
                                        TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                            popKindName: 'popup_cupon_confirm',
                                            taskHandler: 'popup-select',
                                            eventIntervalSpan: new Date() - dialogOpenTime.value
                                        }));
                                        return [
                                            2
                                        ];
                                }
                            });
                        })).catch(function() {
                            console.log('cancel');
                            isShowCouponPopup.value = false;
                            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                popKindName: 'popup_cupon_confirm',
                                taskHandler: 'popup-quit',
                                eventIntervalSpan: new Date() - dialogOpenTime.value
                            }));
                            contractCouponData.value[currentContractId.value].eCouponCode = '';
                        });
                    } else {
                        isShowCouponPopup.value = false;
                    }
                    return [
                        2
                    ];
                });
            });
            return function closeCouponPopup() {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            __sfc: true,
            userStore: userStore,
            route: route,
            router: router,
            active: active,
            oldId: oldId,
            repayList: repayList,
            reqContractDetail: reqContractDetail,
            contractCouponData: contractCouponData,
            currentContractId: currentContractId,
            currentCouponCode: currentCouponCode,
            currentContractCouponList: currentContractCouponList,
            getCouponText: getCouponText,
            getFormatMoney: getFormatMoney,
            reqCouponList: reqCouponList,
            init: init,
            currPlanObj: currPlanObj,
            showCostPopup: showCostPopup,
            goRepay: goRepay,
            trackClick: trackClick,
            isShowPayAllPopup: isShowPayAllPopup,
            isShowCostDetail: isShowCostDetail,
            clickHelp: clickHelp,
            isShowCouponPopup: isShowCouponPopup,
            showCouponPopup: showCouponPopup,
            selectCoupon: selectCoupon,
            reqBindCouponOnRepay: reqBindCouponOnRepay,
            closeCouponPopup: closeCouponPopup,
            couponPopup: couponPopup,
            payAllPopup: payAllPopup,
            costDetailPopup: costDetailPopup,
            formatAmount: formatAmount,
            formatDate: formatDate,
            customFormatDate: customFormatDate
        };
    }
};
